export const IDS = {
  SECTION: 'ps',
  TITLE: 'ps-title',
  BODY: 'ps-body',
  BODY_LINK: 'ps-body-link',
  GALLERY: 'ps-gallery',
  IMAGE: 'ps-image',
} as const;
